<template>
    <v-container fluid grid-list-md>
    <v-layout v-if="!mobileScreen" row wrap>
        <v-flex d-flex xs4 sm4 md4>
        </v-flex>
      <v-flex d-flex xs4 sm4 md4>
        <v-card color="white">
            <v-card-title primary class="title grey ">
                <span><v-icon large color="white">fiber_manual_record</v-icon></span>{{kontaktInfo1}}
            </v-card-title>
            <v-card-text>
                <p>{{ kontaktInfo2a }} {{ kontaktInfo2b }}</p>
                <p>{{ kontaktInfo2c }}</p>

                <p>{{ kontaktInfo3a }}</p>
                <p>{{ kontaktInfo3b }}</p>
                <p>{{ kontaktInfo3c }}</p>

                <p>{{ kontaktInfo4a }}</p>
                <p>{{ kontaktInfo4b }}</p>
                <!--<p>{{ kontaktInfo4c }}</p>-->
                <v-btn
                    color="blue-grey"
                    class="white--text"
                    @click="onSend"
                    block
                    >
                    Email
                    <v-icon right dark>email</v-icon>
                </v-btn>
            </v-card-text>
        </v-card>
      </v-flex>
      <v-flex d-flex xs4 sm4 md4>
        </v-flex>
    </v-layout>
    <v-layout v-if="mobileScreen" row wrap>
      <v-flex d-flex xs12 sm12 md12>
        <v-card color="white">
            <v-card-title primary class="title grey ">
                <span><v-icon large color="white">fiber_manual_record</v-icon></span>{{kontaktInfo1}}
            </v-card-title>
            <v-card-text>
                <p>{{ kontaktInfo2a }} {{ kontaktInfo2b }}</p>
                <p>{{ kontaktInfo2c }}</p>

                <p>{{ kontaktInfo3a }}</p>
                <p>{{ kontaktInfo3b }}</p>
                <p>{{ kontaktInfo3c }}</p>

                <p>{{ kontaktInfo4a }}</p>
                <p>{{ kontaktInfo4b }}</p>
                <!--<p>{{ kontaktInfo4c }}</p>-->
                <v-btn
                    color="blue-grey"
                    class="white--text"
                    @click="onSend"
                    block
                    >
                    Email
                    <v-icon right dark>email</v-icon>
                </v-btn>
            </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Dialog from './image-grid/Dialog'

  import * as newsLatest from '../store-modules/latest'
  import * as newsObj from '../store-modules/news'

  import { EventBus } from '../events'

  const MOBILE_WIDTH = 900

  export default {
    created() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    data () {
      return {
        dialog: false,
        index: 0,
        title: '',
        text: '',
        window: {
          width: 0
        },
        mobileScreen: false,
      }
    },
    mounted(){
      EventBus.$emit('show', false)
    },
    computed: {
        ...mapState('ContactModule', [

            'kontaktInfo1',
            'kontaktInfo2a',
            'kontaktInfo2b',
            'kontaktInfo2c',
            'kontaktInfo3a',
            'kontaktInfo3b',
            'kontaktInfo3c',
            'kontaktInfo4a',
            'kontaktInfo4b',
            'kontaktInfo4c',
          ]),
        ...mapGetters('ContactModule', {
            // map `this.doneCount` to `this.$store.getters.doneTodosCount`
            emailAddress: 'email',
        }),
    },
    methods: {
      onSend(){
        window.location.href = `mailto:${this.emailAddress}`
      },
      handleResize() {
        this.window.width = window.innerWidth
        this.setImgCount()
      },
      setImgCount(){
        if(this.window.width < MOBILE_WIDTH){
          this.mobileScreen = true
        }
        else{
          this.mobileScreen = false
        }
      },
    }
  }
</script>
